import { takeOverMapAction } from 'features/maps/api/maps'
import { getTileLegendStats } from './builder'
import { queryClient } from 'queryClient'

export const takeOverMapActionMutation = {
  mutationFn: (mapId, action) => takeOverMapAction({ mapId, action })
}

const legendKey = 'legend'
const getLegendSettingsQuery = ({
  dataId,
  dataSource,
  dataType,
  dataConnection,
  dataProvider,
  nameField,
  colorField,
  queryParameters
}) => {
  const queryOptions = {
    queryKey: [legendKey, dataId, nameField, colorField],
    queryFn: () =>
      getTileLegendStats({
        source: dataSource,
        sourceType: dataType,
        connection: dataConnection,
        provider: dataProvider,
        label: nameField,
        color: colorField,
        queryParameters
      }),
    staleTime: 0, // Ensures data is always considered stale
    retry: false
  }

  return queryOptions
}

export const getLegendSettings = (dataset, field) => {
  return queryClient.fetchQuery(
    getLegendSettingsQuery({
      dataId: dataset.id,
      dataType: dataset.metadata.sourceType || dataset.metadata.type,
      dataSource: dataset.metadata.source,
      dataConnection: dataset.metadata.connection,
      dataProvider: dataset.metadata.provider,
      nameField: field.name,
      colorField: field.colorColumn,
      queryParameters: dataset.metadata.queryParameters
    })
  )
}
